'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notify = function (_Component) {
    _inherits(Notify, _Component);

    function Notify() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Notify);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notify.__proto__ || Object.getPrototypeOf(Notify)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            notifications: []
        }, _this.myRefs = {}, _this.storeRefCreator = function (id) {
            return function (ref) {
                return _this.myRefs[id] = ref;
            };
        }, _this.pushNotification = function (e) {
            // Generate a unique id using a timestamp and some random for extra fun!
            var newId = Date.now() + '-' + Math.floor(Math.random() * 1e6);

            // Create new notification object
            var notification = {
                id: newId,
                message: e.detail.message
            };

            // Update the state, pushing the notification to the end. We use the pass-a-function method
            // in order to update the state in an 'atomic' way. If this function is called multiple
            // times in quick succession then the referece to `this.state.notifications` in the
            // previous code would actually reference an out-of-date copy of the array by the time the
            // batch state transformations are run.
            _this.setState(function (state) {
                return {
                    notifications: [].concat(_toConsumableArray(state.notifications), [notification])
                };
            }, function () {
                setTimeout(function () {
                    _this.clearNotification(newId);
                }, e.detail.duration || _this.props.duration);
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Notify, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('reactUINotification', this.pushNotification);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.values(this.state.notifications)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    var elm = this.myRefs[item.id];

                    if (elm && elm.style.opacity === '0') {
                        elm.style.opacity = 1;
                        elm.style.top = 0;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('reactUINotification', this.pushNotification);
        }
    }, {
        key: 'clearNotification',
        value: function clearNotification(id) {
            this.setState({
                notifications: this.state.notifications.filter(function (item) {
                    return item.id !== id;
                })
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose(id, e) {
            e.preventDefault();

            this.clearNotification(id);
        }
    }, {
        key: 'handleCloseOver',
        value: function handleCloseOver(e) {
            e.target.style.color = 'rgba(255, 255, 255, 1)';
        }
    }, {
        key: 'handleCloseOut',
        value: function handleCloseOut(e) {
            e.target.style.color = 'rgba(255, 255, 255, 0.7)';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var listStyle = {
                position: 'fixed',
                zIndex: '9999',
                top: '0',
                left: '0',
                width: '100%',
                pointerEvents: 'none'
            };

            var itemStyle = {
                width: '100%',
                maxWidth: '320px',
                margin: '1em auto',
                padding: '0.5em 1em',
                position: 'relative',
                top: '-1em',
                backgroundColor: 'rgba(0,0,0,0.7)',
                color: '#ffffff',
                opacity: 0,
                WebkitTransition: 'all 0.3s',
                msTransition: 'all 0.3s'
            };

            var closeStyle = {
                position: 'absolute',
                top: '0.25em',
                right: '0.5em',
                fontSize: '1.25em',
                color: 'rgba(255,255,255,0.7)'
            };

            var items = this.state.notifications.map(function (item) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: 'react-ui-notification__item',
                        key: item.id,
                        ref: _this2.storeRefCreator(item.id),
                        style: itemStyle
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            className: 'react-ui-notification__close',
                            href: '#',
                            onClick: _this2.handleClose.bind(_this2, item.id),
                            onMouseOut: _this2.handleCloseOut,
                            onMouseOver: _this2.handleCloseOver,
                            style: closeStyle
                        },
                        '×'
                    ),
                    item.message
                );
            });

            return _react2.default.createElement(
                'div',
                { className: 'react-ui-notification', style: listStyle },
                items
            );
        }
    }]);

    return Notify;
}(_react.Component);

Notify.propTypes = {
    duration: _propTypes2.default.number
};
Notify.defaultProps = {
    duration: 3000
};
exports.default = Notify;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/Notify.js
// module id = 433
// module chunks = 0